import RELAXEGAMEActions from './RELAXEGAMEActions'

export default class RELAXSLOTActions extends RELAXEGAMEActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      platform: 'RELAX',
      gameType: 'SLOT',
      gameCode: 'RELAX-SLOT-106',
    }

    this.gameName = 'Beast Mode'
  }
}
